import { createContext } from "react";

const DataGridContext = createContext();

export const DataGridProvider = ({ children }) => {
  const getGridState = () => {
    return JSON.parse(localStorage.getItem("Tilley-DataGrid-States")) || {};
  };

  const setGridState = (gridKey, state) => {
    const existingState = getGridState();
    const updatedState = {
      ...existingState,
      [gridKey]: state ? { ...existingState[gridKey], ...state } : null,
    };
    localStorage.setItem("Tilley-DataGrid-States", JSON.stringify(updatedState));
  };

  return <DataGridContext.Provider value={{ getGridState, setGridState }}>{children}</DataGridContext.Provider>;
};

export default DataGridContext;
